<template>
	<div class="receive-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_receive_page_v2.sec_01.title.one') }}
					<strong>
						{{ $t('new_ui.personal_receive_page_v2.sec_01.title.two') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_receive_page_v2.sec_01.desc.one') }}<br />
					{{ $t('new_ui.personal_receive_page_v2.sec_01.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/login" class="btn-type-01">
						{{ $t('new_ui.personal_receive_page_v2.sec_01.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_receive_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-09">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_receive_page_v2.sec_09.title.one') }}<br />
					{{ $t('new_ui.personal_receive_page_v2.sec_09.title.two') }}
				</h3>
				<p>
					{{ $t('new_ui.personal_receive_page_v2.sec_09.one.desc.one') }}<br />
					{{ $t('new_ui.personal_receive_page_v2.sec_09.one.desc.two') }}
				</p>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.personal_receive_page_v2.sec_03.one.title.one')
							}}<br />
							{{ $t('new_ui.personal_receive_page_v2.sec_03.one.title.two') }}
						</h3>
						<p>
							{{ $t('new_ui.personal_receive_page_v2.sec_03.one.desc.one')
							}}<br />{{
								$t('new_ui.personal_receive_page_v2.sec_03.one.desc.two')
							}}
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgReceiveSec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgReceiveSec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.personal_receive_page_v2.sec_03.two.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.personal_receive_page_v2.sec_03.two.desc.one') }}
							<br />
							{{ $t('new_ui.personal_receive_page_v2.sec_03.two.desc.two') }}
						</p>
					</div>
				</div>
			</div>
		</section>
		<section class="sec-05">
			<div class="container-box">
				<h3>{{ $t('new_ui.personal_receive_page_v2.sec_05.title') }}</h3>
				<img :src="img.imgReceiveSec05" alt="" />
				<p>
					{{ $t('new_ui.personal_receive_page_v2.sec_05.desc.one') }}
				</p>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.personal_receive_page_v2.sec_03.three.title.one')
							}}<br />
							{{ $t('new_ui.personal_receive_page_v2.sec_03.three.title.two') }}
						</h3>
						<p>
							{{ $t('new_ui.personal_receive_page_v2.sec_03.three.desc.one')
							}}<br />{{
								$t('new_ui.personal_receive_page_v2.sec_03.three.desc.two')
							}}
						</p>
						<a href="/auth/register" class="btn-type-02">
							{{ $t('new_ui.personal_receive_page_v2.sec_03.three.btn.one') }}
						</a>
					</div>
					<div class="img-box">
						<img :src="img.imgReceiveSec0303" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgReceiveSec0301 from '@/assets/images/v2/img-receive-sec-03-01.png';
import imgReceiveSec0302 from '@/assets/images/v2/img-receive-sec-03-02.png';
import imgReceiveSec0303 from '@/assets/images/v2/img-receive-sec-03-03.png';
import imgReceiveSec05 from '@/assets/images/v2/img-receive-sec-05.png';

export default {
	data: () => {
		return {
			img: {
				imgReceiveSec0301,
				imgReceiveSec0302,
				imgReceiveSec0303,
				imgReceiveSec05,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
